export default __webpack_public_path__ + "static/media/М.6e1d0fec.png";